/** The running execution a user prompt was steered into, saved on the user
 *  message (`metadata.steered_into_execution_id`). */
export function steeredIntoExecutionId(
  metadata: Record<string, unknown> | null | undefined,
): string | undefined {
  const value = metadata?.steered_into_execution_id;
  return typeof value === "string" && value ? value : undefined;
}
